<template>

  <div v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-container>
      <el-header style="height: 100%">
        <head-page :head_page_type=false ref="head_page_1"></head-page>
      </el-header>
      <el-main>
        <div>
          <head-menu :is-home-page=true :has-back=true @go-back-click="backToLogin" >
            <template #button-group-left-toggle>
            </template>
          </head-menu>
          
          <div class="choose_city_content" :style="{width: cityChosed? '585px' : '100%'}">
            <el-row>
              <p class="p_city_title_global">
                <strong>CHOOSE YOUR CITY</strong>
              </p>
              <p class="p_city_time_global">
                <a style="font-weight: bold;">{{day}},</a> <a>{{date}}</a>
              </p>
              <p class="p_city_hello_global">
                {{ $t('message.Hello') }}, {{user}}
              </p>
              <div style="padding-left: 105px; width: 485px; margin-top: 20px; color: black">
                <el-divider class="divider_left"></el-divider>
                <a style="font-size: 12px; margin: 0 20px; font-weight: bold; cursor: default; text-shadow: 0.1em 0.1em 0.2em grey;">Please select a city to explore more</a>
                <el-divider class="divider_right"></el-divider>
              </div>
              <el-row style="width: 385px; margin-left: 98px" :gutter="10">
                <el-col :span="8">
                  <button class="city_selection" @focus="cityChosed = 'nanjing'" @blur="cityChosed = ''">
                    NANJING
                  </button>
                </el-col>
                <el-col :span="8">
                  <button class="city_selection" @focus="cityChosed = 'wuhan'" @blur="cityChosed = ''">
                    WUHAN
                  </button>
                </el-col>
                <el-col :span="8">
                  <button class="city_selection" @focus="cityChosed = 'nanjing'" @blur="cityChosed = ''">
                    CHONGQING
                  </button>
                </el-col>
              </el-row>
              <el-row style="width: 385px; margin-left: 98px" :gutter="10">
                <el-col :span="8">
                  <button class="city_selection" @focus="cityChosed = 'shenzhen'" @blur="cityChosed = ''">
                    SHENZHEN
                  </button>
                </el-col>
                <el-col :span="8">
                  <button class="city_selection" @focus="cityChosed = 'nanjing'" @blur="cityChosed = ''">
                    CHENGDU
                  </button>
                </el-col>
                <el-col :span="8">
                  <button class="city_selection" @focus="cityChosed = 'nanjing'" @blur="cityChosed = ''">
                    SHANGHAI
                  </button>
                </el-col>
              </el-row>
            </el-row>
          </div>

          <div class="choose_city_content_2" :style="{width: cityChosed? 'calc(100% - 620px)' : '0'}">
          </div>

          <el-row :gutter="20" style="background-color: rgb(248, 248, 249); padding-bottom: 10px; margin: 0;">
            <el-col :span="12">
              <div class="footer float-right" style="text-align: center">
                <p style="margin-top: 15px; color: #53adbc; font-size: 20px;"> Population </p>
                <p style="margin-top: 5px; font-size: 50px; font-weight: bold;"> 19,648,200 </p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="footer" style="text-align: center">
                <p style="margin-top: 15px; color: #53adbc; font-size: 20px;"> Bus Lines </p>
                <p style="margin-top: 5px; font-size: 50px; font-weight: bold;"> 575 </p>
              </div>
            </el-col>
          </el-row>

          <footer style="padding: 50px 0">
          </footer>
        </div>
        
      </el-main>
    </el-container>

  </div>

</template>

<script>
  import headPage from './components/head_page_1.vue'
  import headMenu from './components/head_menu_1.vue'
  import toggleMenu from './components/toggle_menu_1.vue'
  import axios from 'axios';
  import _global from './components/global.vue';
  export default {
    name: 'choose_city',
    data() {
      return {
        alreadyClicked:false,
        version :'',
        num_population: 0,
        num_audience: 0,
        submit_show: false,
        city_info: '',
        chosen_city: "CHOOSE YOUR CITY",
        total_num_population: 0,
        total_num_audience: 0,
        bus_line_number: 0,
        total_bus_length: 0,
        hover: false,
        first_page: true,
        user: 'Visitor',
        style_nanjing: false, //to be city_list['Nanjing']=false
        style_wuhan: false,
        num_bus_line: 0,
        num_kms_covered: 0,
        lang: 'en',
        loading: false,
        activeName: 'first',
        dataValueBadge: 0,
        // isAll:false,
        // isNanjing:false,
        // isWuhan:false,
        // isShenzhen:false,
        is_national : false,
        view_nanjing : false,
        view_wuhan : false,
        view_shenzhen : false,
        view_statistics:false,
        view_package_list:false,
        published_package_list:[],
        selected_package_package_id:'',
        selected_package:{},
        notExistPackageId:true,
        //isDirector:false,
        packageValidityPeriod:'',
        pageWidth: screen.width,
        cityChosed: "",
      }
    },
    computed: {
      day: function() {
        let week;
        let date = new Date();
        if (date.getDay() == 0) week = this.$t('message.Sunday')
        if (date.getDay() == 1) week = this.$t('message.Monday')
        if (date.getDay() == 2) week = this.$t('message.Tuesday')
        if (date.getDay() == 3) week = this.$t('message.Wednesday')
        if (date.getDay() == 4) week = this.$t('message.Thursday')
        if (date.getDay() == 5) week = this.$t('message.Friday')
        if (date.getDay() == 6) week = this.$t('message.Saturday')

        return week;
      },
      date: function() {
        let date_org = new Date();
        let date_arr = String(date_org).split(" ");
        if (date_arr[1] == 'Jan') date_arr[1] = this.$t('message.Jan')
        if (date_arr[1] == 'Feb') date_arr[1] = this.$t('message.Feb')
        if (date_arr[1] == 'Mar') date_arr[1] = this.$t('message.Mar')
        if (date_arr[1] == 'Apr') date_arr[1] = this.$t('message.Apr')
        if (date_arr[1] == 'May') date_arr[1] = this.$t('message.May')
        if (date_arr[1] == 'Jun') date_arr[1] = this.$t('message.Jun')
        if (date_arr[1] == 'Jul') date_arr[1] = this.$t('message.Jul')
        if (date_arr[1] == 'Aug') date_arr[1] = this.$t('message.Aug')
        if (date_arr[1] == 'Sep') date_arr[1] = this.$t('message.Sep')
        if (date_arr[1] == 'Oct') date_arr[1] = this.$t('message.Oct')
        if (date_arr[1] == 'Nov') date_arr[1] = this.$t('message.Nov')
        if (date_arr[1] == 'Dec') date_arr[1] = this.$t('message.Dec')
        return date_arr[2] + ' ' + date_arr[1] + ' ' + date_arr[3];
      },
      localLang() {
        return this.$i18n.locale;
      }
    },
    watch:{
      selected_package_package_id: function(){
        for (let ele in this.published_package_list) {
          if(this.published_package_list[ele]['package_id']==this.selected_package_package_id){
              this.selected_package = this.published_package_list[ele]
              //Update packageValidityPeriod with Character from/to
              this.packageValidityPeriod = this.$t('message.From') + ' ' + this.selected_package.valid_period_start + ' ' + this.$t('message.to')+ ' ' + this.selected_package.valid_period_end
          }
        } 
        this.$store.state.package.selected_package.selected_package_package_id = this.selected_package_package_id
        if(this.selected_package_package_id != ''){
          this.notExistPackageId = false
        }else{
          this.notExistPackageId = true
        }
      },
      localLang() {
        if (this.packageValidityPeriod && this.packageValidityPeriod.length>0) {
          this.packageValidityPeriod = this.$t('message.From') + ' ' + this.selected_package.valid_period_start + ' ' + this.$t('message.to')+ ' ' + this.selected_package.valid_period_end
        }
      }
    },
    components: {
      headPage,
      headMenu,
      toggleMenu
    },
    created() {
      this.loading = true;
      if (JSON.parse(sessionStorage.getItem('User')) != null) {
        this.user = JSON.parse(sessionStorage.getItem('User')).split('.')[0].toUpperCase();
      }
      window.addEventListener("resize", this.resizeHandler);
    },
    mounted() {
      this.getPageAuthority()
      this.getCityInfo();
      this.getReportLength()
      this.$refs.head_page_1.update_user_name();
      this.lang = JSON.parse(sessionStorage.getItem('lang'));
      this.$i18n.locale = this.lang;
      this.$refs.head_page_1.switchLang(this.lang);
      this.chosen_city = this.$t('message.Choose_one_city');
      //this.getCityAccess()
    },
    updated() {
      if (this.total_num_population & this.total_num_audience == 0) {
        this.open1();
      }
    },
    methods: {
      getPageAuthority(){
        if (JSON.parse(sessionStorage.getItem('UserAuthority')) != null) {
        let userAuthority = JSON.parse(sessionStorage.getItem('UserAuthority'));
        // this.isDirector = userAuthority['isDirector']
        // this.isAll = userAuthority['isAll']
        // this.isNanjing = userAuthority['isNanjing']
        // this.isWuhan= userAuthority['isWuhan']
        this.is_national = userAuthority['is_national']
        this.view_nanjing = userAuthority['view_nanjing']
        this.view_wuhan = userAuthority['view_wuhan']
        this.view_shenzhen = userAuthority['view_shenzhen']
        this.view_statistics = userAuthority['view_statistics']
        this.view_package_list = userAuthority['view_package_list']
      }
      },
      
      // getCityAccess() {
      //   let api_url = _global.serverSrc + '/city_access_check/';
      //   let obj = new Object()
      //   obj.email = JSON.parse(sessionStorage.getItem('User'))
      //   axios.post(api_url, obj)
      //     .then(response => {
      //       let city_access = JSON.parse(response.data[0].city_access.replace(/'/g,'\"'))
      //       if (city_access.indexOf("National")>=0) {
      //         this.isAll=true
      //       }else if (city_access.indexOf("Nanjing")>=0){
      //         this.isNanjing = true
      //       }else if (city_access.indexOf("Wuhan")>=0){
      //         this.isWuhan = true
      //       }
      //     })
      //     .catch(function(error) {});
      // },
      
      getReportLength() {
        let api_url = _global.serverSrc + '/report_length/' + '?format=json';
        let obj = new Object()
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data.report_length) {
              this.dataValueBadge = response.data.report_length[0].report_number
            }
          })
          .catch(function(error) {});
      },
      goHistory() {
        this.$router.push('./history')
      },
      goStatistics() {
        this.$router.push('./statistics')
      },
      handleClick(tab, event) {
        this.alreadyClicked = true
        this.chosen_city = tab.name
        if (tab.index == 0) {
          //  global
          this.getCityInfo()
        } else if (tab.name == "Nanjing") {
          // Nanjing
          this.getCityInfoByName('Nanjing')
          this.resetPackageList()
          this.getPackageList('Nanjing')
        } else if (tab.name == "Wuhan") {
          // Wuhan
          this.getCityInfoByName('Wuhan')
          this.resetPackageList()
          this.getPackageList('Wuhan')
        }
      },

      goNanjing: function(event) {
        this.getCityInfoByName(event);
        this.submit_show = true;
        this.chosen_city = this.$i18n.messages[this.$i18n.locale].message.Nanjing;
        this.first_page = false;
        this.style_nanjing = true;
        this.style_wuhan = false;
      },

      goWuhan: function(event) {
        this.getCityInfoByName(event);
        this.submit_show = true;
        this.chosen_city = this.$i18n.messages[this.$i18n.locale].message.Wuhan;
        this.first_page = false;
        this.style_wuhan = true;
        this.style_nanjing = false;
      },
      open1() {
        const h = this.$createElement;
        this.$notify({
          title: 'Server Error',
          message: h('i', {
            style: 'color: teal'
          }, message.Please_Contact_IT)
        });
      },

      getCityInfo() {
        let api_url = _global.serverSrc + '/city_info/' + '?kvalue=';
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        this.$axios.post(api_url, obj)
          .then(response => {
            if (response.data) {
              this.city_info = response.data.city_info;
              let total_audience = 0;
              let total_population = 0;
              let bus_line_number = 0;
              let total_bus_length = 0;
              for (let ele in response.data.city_info) {
                total_audience += response.data.city_info[ele].audience;
                total_population += response.data.city_info[ele].population;
                bus_line_number += response.data.city_info[ele].bus_line_number;
                total_bus_length += response.data.city_info[ele].total_bus_length;
              }
              this.total_num_population = total_population.toLocaleString();
              this.total_num_audience = total_audience.toLocaleString();
              this.bus_line_number = bus_line_number.toLocaleString();
              this.total_bus_length = total_bus_length.toLocaleString();
            }
            this.loading = false;
          })
          .catch(function(error) {
            this.loading = false;
          });
      },
      goTraining: function(e){
        
        const quizSrc = 'http://10.11.1.87:8060/#/quiz';
        window.open(quizSrc);
      },

      doSubmit: function(event) {
        if (this.chosen_city) {
          

          this.$router.push({
            path: '/information',
            query: {
              chosen_city: this.chosen_city
            }
          });
        } else {
          this.open2();
        }

      },
      open2: function() {
        const h = this.$createElement;
        this.$notify({
          title: this.$i18n.messages[this.$i18n.locale].message.Error,
          message: h('i', {
            style: 'color: teal'
          }, this.$i18n.messages[this.$i18n.locale].message.Please_select_a_city_first)
        });
      },
      goHome: function(event) {
        this.$router.go(0);
      },
      backToLogin: function(event) {
        this.$router.push({
          path: '/',
        });
      },
      goPackage(){
        this.$router.push({
          path: '/package_history',
        });
      },
      getCityInfoByName: function(city_name) {
        let api_url = _global.serverSrc + '/city_info/' + '?kvalue=' + city_name;
        let obj = {'email': JSON.parse(sessionStorage.getItem('User'))}
        //let api_url = 'http://' +'127.0.0.1:8000' + '/city_info/'+'?kvalue='+city_name;
        var _self = this;
        this.$axios.post(api_url, obj).then(response => {
            if (response.data) {
              _self.total_num_population = response.data.city_info[0]['population'].toLocaleString();
              _self.total_num_audience = response.data.city_info[0]['audience'].toLocaleString();
              _self.bus_line_number = response.data.city_info[0]['bus_line_number'].toLocaleString();
              _self.total_bus_length = response.data.city_info[0]['total_bus_length'].toLocaleString();
            }
            _self.loading = false;
          })
          .catch(function(error) {
            _self.loading = false;
          });
        this.chosen_city = city_name;
      },
      getPackageList(city_name){
        let api_url = _global.serverSrc + '/package_display/' 
        var _self = this;
        let published_package_list = []

        let obj = {}
        obj.email = JSON.parse(sessionStorage.getItem('User'))
        obj.package_publish_status = 'NotExpired'

        this.$axios.post(api_url,obj).then(response => {
            if (response.data.package_list) {
              for (let ele of response.data.package_list){
                if (ele.publish_status ==1 && ele.city==city_name){
                  published_package_list.push(ele)
                }
              }
              //this.$store.state.package.published_package = response.data
            this.published_package_list = published_package_list
            }
            _self.loading = false;
          })
          .catch(function(error) {
            _self.loading = false;
          });
      },
      resetPackageList(){
        this.selected_package_package_id = ''
        this.selected_package = {}
        this.published_package_list = {}

      },
      goPackageBoard(){
        //this.$router.push('./package_board')
        this.$router.push({
              path: '/package_board',
              query: {
                back_url: '/choose_city'
              }
            });
      },
      resizeHandler() {
        this.pageWidth = screen.width
      }
    },
    destroyed() {
      window.removeEventListener("resize", this.resizeHandler);
    }
  }
</script>

<style lang="scss" scoped>
  .choose_city_content {
    background-image: url(./assets/city_back_big_screen.png);
  	height:80%;
  	width:100%;
  	background-size: cover;
  	background-repeat:no-repeat;
  	background-position:left;
  	text-align: left;
    height: 500px;
    transition: width 2s;
    display: inline-block;
    vertical-align: top;
  }

  .choose_city_content_2 {
    background-image: url(./assets/wuhan_back_big_screen.png);
  	height:80%;
  	background-size: cover;
  	background-repeat:no-repeat;
  	background-position:center;
  	text-align: left;
    height: 500px;
    transition: width 2s;
    display: inline-block;
    vertical-align: top;
  }
  
  .choose_city_content_2 {
    background-image: url(./assets/wuhan_back_big_screen.png);
  	height:80%;
  	background-size: cover;
  	background-repeat:no-repeat;
  	background-position:center;
  	text-align: left;
    height: 500px;
    transition: width 2s;
    display: inline-block;
    vertical-align: top;
  }

  .version_href{
    cursor: pointer;
    user-select: none;
    font-size: 20px;
  }
  
  .level3_div {
    height: 100px;
    margin: 20px;
  }

  .p_city_title_global {
    color:black;
    text-shadow: 0.1em 0.1em 0.2em grey;
    font-size: 22px;
    padding: 130px 0 0 100px;
    cursor: default;
    user-select: none;
  }

  .p_city_time_global {
    color:black;
    text-shadow: 0.1em 0.1em 0.2em grey;
    font-size: 16px;
    padding-left: 100px;
    cursor: default;
    user-select: none;
  }

  .p_city_hello_global {
    color:black;
    text-shadow: 0.1em 0.1em 0.1em grey;
    font-size: 60px;
    padding-left: 97px;
    font-weight: lighter;
    margin-top: 5px;
    cursor: default;
    user-select: none;
  }

  .el-tabs--top /deep/ .el-tabs__nav.is-top {
    @media (max-width:767px) {
      width: 100%;
      overflow-x: scroll;
    }
  }

  div /deep/ .el-divider--horizontal {
    background-color: black;
    text-shadow: 0.1em 0.1em 0.2em grey;
    margin: 0 0 4px 0;
    display: inline-block;
    height: 1.5px
  }

  .divider_left {
    width: 30px;
  }

  .divider_right {
    width: 89px;
  }
  
  .city_selection {
    width: 100%;
    height: 50px;
    text-align: center;
    margin-top: 10px;
    background-color: rgba(255,255,255, 0.85);
    cursor: pointer;
    border-radius: 10px;
    border: 0;
    color: black;
    text-shadow: 0.1em 0.1em 0.2em grey;
    font-size: 14px;
    position: relative;
  }

  .city_selection:hover {
    background-color: rgba(255,255,255, 1);
  }

  .city_selection:focus {
    outline: 0;
    background-color: rgba(83, 173, 188, 0.7);
  }

  .city_selection:focus:hover {
    outline: 0;
    background-color: rgba(83, 173, 188, 0.85);
  }

  .footer {
    width: 300px
  }

</style>
